<h3>How do I get access?</h3>

<h2>
   If you already have a GoArmy Edge Football account, 
   follow the link below to access GoArmy Edge Football VR.
</h2>

<h2>
   <a href="https://www.meta.com/experiences/quest/3818712738236099/" target="_blank">GoArmy Edge Football VR on the Meta Quest</a>
</h2>

<h2>Don't have a GoArmy Edge Football account?  First select one of the download options below. <br> You must have an existing GoArmy Edge Football account
   in order to use GoArmy Edge Football VR.
</h2>

<div class="button-area">
  <a *ngIf="sportLinkApple" angulartics2On="click" target="_blank"
  angularticsCategory="Download"
     angularticsLabel="{{ sport }} iOS App"
     [angularticsProperties]="{ label: 'Click from ' + sport + ' page' }"
     href="{{ sportLinkApple }}"
     class="store apple">
     <img src="/assets/images/store-apple.svg" alt="">
  </a>
  <a *ngIf="sportLinkGoogle" angulartics2On="click" target="_blank"
  angularticsCategory="Download"
     angularticsLabel="{{ sport }} Android App"
     [angularticsProperties]="{ label: 'Click from ' + sport + ' page' }"
     href="{{ sportLinkGoogle }}"
     class="store google">
     <img src="/assets/images/store-google.svg" alt="">
  </a>
  <a *ngIf="sportLinkWindows" angulartics2On="click" target="_blank" 
  angularticsCategory="Download"
     angularticsLabel="{{ sport }} Windows App"
     [angularticsProperties]="{ label: 'Click from ' + sport + ' page' }"
     href="{{ sportLinkWindows }}"
     class="store microsoft">
     <img src="/assets/images/store-windows.svg" alt="">
  </a>
  <a *ngIf="sportLinkWebgl" angulartics2On="click" 
  angularticsCategory="Download"
     angularticsLabel="{{ sport }} WebGL"
     [angularticsProperties]="{ label: 'Click from ' + sport + ' page' }"
     href="{{ sportLinkWebgl }}"
     target="_blank"
     class="store webplayer">
     <img src="/assets/images/web-player.svg" alt="">
  </a>
</div>